const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoCompanyDistributionAreasQuery: any = {
    GetServiceDistributionTypes: Backofficebff + '/v1/cargodistributionarea/get-service-distribution-types',
};
